import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['code', 'defaultIcon', 'checkIcon']

  declare readonly codeTarget: HTMLElement
  declare readonly defaultIconTarget: HTMLElement
  declare readonly checkIconTarget: HTMLElement

  copy (): void {
    const text = this.extractText(this.codeTarget)
    navigator.clipboard.writeText(text).then(() => {
      this.showCheckIcon()
    }).catch((err: unknown) => {
      console.error('Failed to copy!', err)
    })
  }

  private extractText (el: HTMLElement): string {
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
      return el.value.trim()
    }
    const textContent = el.textContent ?? ''
    return textContent.trim()
  }

  private showCheckIcon (): void {
    this.defaultIconTarget.classList.add('hidden')
    this.checkIconTarget.classList.remove('hidden')

    setTimeout(() => {
      this.defaultIconTarget.classList.remove('hidden')
      this.checkIconTarget.classList.add('hidden')
    }, 2000)
  }
}
